// Import Owl Carousel
import 'owl.carousel';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import pageTemplateServicesPage from './routes/services';
import pageTemplateServicesSubPage from './routes/services';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // Services Page
  pageTemplateServicesPage,
  // Services Sub Page
  pageTemplateServicesSubPage,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());
